// The roadmap page's description is shown on a viewer's first visit and then
// folded away (2026-09-27 assessment: title, description, run banner, health
// tiles and two filter rows pushed the tabs below the fold on a laptop). A
// per-viewer convenience, so browser storage is the right home; every read
// and write is guarded because storage can be blocked or throw in private
// windows and previews, and the page must render either way.

export const INTRO_SEEN_KEY = 'roadmap.introSeen';

export type StorageLike = Pick<Storage, 'getItem' | 'setItem'>;

export function storage(): StorageLike | null {
  try {
    return typeof window !== 'undefined' && window.localStorage ? window.localStorage : null;
  } catch {
    return null;
  }
}

/** True once this browser has seen the description; false when storage is unavailable. */
export function introSeen(store: StorageLike | null = storage()): boolean {
  try {
    return store?.getItem(INTRO_SEEN_KEY) === '1';
  } catch {
    return false;
  }
}

export function markIntroSeen(store: StorageLike | null = storage()): void {
  try {
    store?.setItem(INTRO_SEEN_KEY, '1');
  } catch {
    // storage blocked: the description simply shows again next visit
  }
}
